import type { ComplianceCalendarType } from "@/redux/complianceCalendar/complianceCalendarType";

export const complianceCalendarReducer = {
  resetComplianceCalendarError: (state: ComplianceCalendarType) => {
    state.error = null;
  },
  resetComplianceCalendarSuccess: (state: ComplianceCalendarType) => {
    state.success = null;
  },

  resetComplianceCalendarMessage: (state: ComplianceCalendarType) => {
    state.message = null;
  },

  resetComplianceCalendarStatusCode: (state: ComplianceCalendarType) => {
    state.statusCode = null;
  },
  resetComplianceCalendarList: (state: ComplianceCalendarType) => {
    state.complianceCalendarList = [];
  },
  resetComplianceCalendarFetching: (state: ComplianceCalendarType) => {
    state.fetching = false;
  },
};
